import React from "react";
import {connect} from "react-redux";
import DateRange from './DateRange';
import DataTable from '../../components/Table';
import {
    proposalCount,
    getSelectedProposalData,
    changeType,
    getPaymentMethodData,
    resetPaymentMethod
} from '../../store/actions/dashboardActions';
import MobilePopUp from "../../components/MobilePopUp/MobilePopUp";

class OldProposalDashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showDateRange: false,
            showPaymentPopUp: false,
            selectedPn: ""
        };
    }

    componentDidMount() {
        this.props.proposalCount((data) => {

        });
        this.props.getSelectedProposalData('day', false);
    }

    componentWillReceiveProps(nextProps) {

    }

    getProposals = (type) => {
        if (type !== this.props.dashboardData.selectedType) {
            this.props.getSelectedProposalData(type, false)
            this.setState({
                showDateRange: false
            })
        }
    }

    openDateRange = () => {
        this.setState({showDateRange: true});
        this.props.changeType('dateRange');
    }
    applyDateRange = (startDtae, endDate) => {
        this.props.getSelectedProposalData('fromDate=' + startDtae + '&toDate=' + endDate, true)
    }

    render() {
        return (
            <>
                <div className="view-options">
                    <div
                        onClick={() => {
                            this.getProposals('day')
                        }}
                        className={`${this.props.dashboardData.selectedType === 'day' ? 'view-count selected' : 'view-count'}`}>
                        <h4>Today</h4>
                        <div className="proposal-count">{this.props.dashboardData.proposalCount.today}</div>
                    </div>
                    <div
                        onClick={() => {
                            this.getProposals('week')
                        }}
                        className={`${this.props.dashboardData.selectedType === 'week' ? 'view-count selected' : 'view-count'}`}>
                        <h4>Week</h4>
                        <div className="proposal-count">{this.props.dashboardData.proposalCount.week}</div>
                    </div>
                    <div
                        onClick={() => {
                            this.getProposals('month')
                        }}
                        className={`${this.props.dashboardData.selectedType === 'month' ? 'view-count selected' : 'view-count'}`}>
                        <h4>Month</h4>
                        <div className="proposal-count">{this.props.dashboardData.proposalCount.month}</div>
                    </div>
                    <div
                        onClick={() => {
                            this.openDateRange()
                        }}
                        className={`${this.state.showDateRange ? 'view-count selected' : 'view-count'}`}>
                        <h4>Select By Date</h4>
                        {/* <div className="proposal-count">{this.props.dashboardData.proposalCount.today}</div> */}
                    </div>
                </div>
                {
                    this.state.showDateRange &&
                    <div className="date-range">
                        <DateRange
                            applyDateRange={this.applyDateRange}
                            // startTimestamp={startTimestamp}
                            // endTimestamp={endTimestamp}
                            // onCancel={() => {setShowByDateRange(false); setSelectedFilter("all") }}
                        />
                    </div>
                }
                {this.props.dashboardData.selectedProposals ? <DataTable
                    cellHeaders={['Policy ID', 'Proposal Number', 'Policy Number',
                        'Payment Status',
                        'Payment Transaction Date',
                        'Partner Name',
                        'Total Premium - without GST',
                        'Sum Assured',
                        'Frequency',
                        'Quote No',
                        'Email',
                        'Phone Number',
                        'Policy Created',
                        'Policy Status',
                        'Journey Status',
                        'Journey Option',
                        'Under-writing Decision',
                        'Created On',
                        'Agent Code',
                        'Channel',
                        'Sub Channel',
                        'Proposer Name',
                        'Product Name',
                        'Total Premium',
                        "Payment Method",
                        'Renewal Method Selected',
                        'Vertical',
                        'Sub Vertical',
                        'Lg Code',
                        'Bharti Axa Emp Code',
                        'Centre Head',
                        'Bank Customer Id',
                        'Branch Code',
                        'Branch Name',
                        'Bank Source Code',
                        'Bank Referal Code',

                    ]}
                    data={this.props.dashboardData.selectedProposals}
                    keys={['proposalId', 'proposalNumber', 'policyNumber','payStatus','transactionDate','partnerName', 'premium','sumAssured', 'premiumPaymentMode', 'quoteRefNumber', 'emailId', 'mobileNumber', 'policyCreated', 'policyStatus', 'journeyStatus', 'selectedJourney',
                        'underWritingDecision', 'createdOn', 'agentCode', 'channel', 'subChannel', 'proposerName', 'productName', 'totalPremium', "customButtons", 'renewalPaymentMethod',
                        'vertical', 'subVertical', 'lgCode', 'bhartiAxaEmpCode', 'centreHead', 'bankCustomerId', 'branchCode', 'branchName',
                        'bankSourceCode', 'bankReferralCode']}
                    uniqueKey={'proposalNumber'}
                    fileName="Proposals"
                    addSerialNo={true}
                    customButtonName="View"
                    onCustomButtonClick={(item) => {
                        this.props.getPaymentMethodData(item.proposalNumber);
                        this.setState({
                            selectedPn: item.proposalNumber,
                            showPaymentPopUp: true
                        })
                    }}
                    showExcelDownload={true}
                    PerPageApiData={false}
                    paginationItems={this.props.dashboardData.selectedProposals}
                    alwaysShown={false}
                /> : ''}
                {
                    this.state.showPaymentPopUp && <MobilePopUp
                        heading={`Payment Method for ${this.state.selectedPn}`}
                        onClose={() => {
                            this.setState({
                                selectedPn: "",
                                showPaymentPopUp: false
                            });
                            this.props.resetPaymentMethod()
                        }}
                    >
                        <div className="dashboard-payment-method-list">
                            {
                                this.props.paymentMethodList.length > 0 && this.props.paymentMethodList !== "No Data" ?
                                    this.props.paymentMethodList.map(item => <li>
                                        {item}
                                    </li>) : this.props.paymentMethodList
                            }
                        </div>

                    </MobilePopUp>
                }
            </>)
    }
}

const mapStateToProps = (state) => {
    // console.log('stttt-<', state)
    return {
        dashboardData: state.dashboardData,
        authentication: state.authentication,
        paymentMethodList: state.dashboardData.paymentMethodList,

    };
};

export default connect(mapStateToProps, {
    proposalCount,
    getSelectedProposalData,
    changeType,
    getPaymentMethodData,
    resetPaymentMethod,
})(OldProposalDashboard);
